/**
 * 店舗タイプ（業種）定義
 * 新規店舗導入時のブランディングプリセット
 */

export const STORE_TYPES = {
  monja: {
    label: 'もんじゃ焼き',
    labelEn: 'Monjayaki',
    icon: '🔥',
    colors: {
      primary: '#d32f2f',
      secondary: '#ff6f00',
      accent: '#ffc107',
    },
    welcomeMessage: 'ようこそ！熱々のもんじゃ焼きをお楽しみください 🔥',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1617196034796-73dfa7b1fd56?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600&h=400&fit=crop',
      seafood: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['もんじゃ', 'お好み', '鉄板', '焼き'],
  },
  okonomiyaki: {
    label: 'お好み焼き',
    labelEn: 'Okonomiyaki',
    icon: '🥢',
    colors: {
      primary: '#e65100',
      secondary: '#ff9800',
      accent: '#ffc107',
    },
    welcomeMessage: 'ようこそ！焼きたてのお好み焼きをどうぞ 🥢',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['お好み', '焼き', '鉄板'],
  },
  ramen: {
    label: 'ラーメン',
    labelEn: 'Ramen',
    icon: '🍜',
    colors: {
      primary: '#f57c00',
      secondary: '#ffb74d',
      accent: '#fff176',
    },
    welcomeMessage: 'ようこそ！こだわりの一杯をお楽しみください 🍜',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600&h=400&fit=crop',
      noodle: 'https://images.unsplash.com/photo-1557872943-16a5ac26437e?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['ラーメン', '麺', 'つけ麺', '餃子'],
  },
  izakaya: {
    label: '居酒屋',
    labelEn: 'Izakaya',
    icon: '🍶',
    colors: {
      primary: '#5d4037',
      secondary: '#8d6e63',
      accent: '#ffab91',
    },
    welcomeMessage: 'ようこそ！美味しいお酒と料理をどうぞ 🍶',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1553621042-f6e147245754?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600&h=400&fit=crop',
      yakitori: 'https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['おつまみ', '焼き鳥', '刺身', '揚げ物', '日本酒', 'ビール'],
  },
  cafe: {
    label: 'カフェ',
    labelEn: 'Cafe',
    icon: '☕',
    colors: {
      primary: '#6d4c41',
      secondary: '#a1887f',
      accent: '#ffcc80',
    },
    welcomeMessage: 'ようこそ！ゆったりとしたひとときを ☕',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=600&h=400&fit=crop',
      dessert: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['コーヒー', 'ケーキ', 'スイーツ', 'サンドイッチ', 'パン'],
  },
  sushi: {
    label: '寿司',
    labelEn: 'Sushi',
    icon: '🍣',
    colors: {
      primary: '#1565c0',
      secondary: '#42a5f5',
      accent: '#80deea',
    },
    welcomeMessage: 'ようこそ！新鮮なお寿司をお楽しみください 🍣',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1559339352-11d035aa65de?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['寿司', '刺身', '海鮮', 'まぐろ', 'サーモン'],
  },
  yakiniku: {
    label: '焼肉',
    labelEn: 'Yakiniku',
    icon: '🥩',
    colors: {
      primary: '#c62828',
      secondary: '#ef5350',
      accent: '#ffab91',
    },
    welcomeMessage: 'ようこそ！極上のお肉をご堪能ください 🥩',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['カルビ', 'ロース', 'ホルモン', 'タン', '肉'],
  },
  italian: {
    label: 'イタリアン',
    labelEn: 'Italian',
    icon: '🍝',
    colors: {
      primary: '#2e7d32',
      secondary: '#66bb6a',
      accent: '#c5e1a5',
    },
    welcomeMessage: 'Benvenuto！本格イタリアンをどうぞ 🍝',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600&h=400&fit=crop',
      pizza: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['パスタ', 'ピザ', 'リゾット', 'ワイン', 'ドルチェ'],
  },
  french: {
    label: 'フレンチ',
    labelEn: 'French',
    icon: '🥐',
    colors: {
      primary: '#7b1fa2',
      secondary: '#ba68c8',
      accent: '#e1bee7',
    },
    welcomeMessage: 'Bienvenue！優雅なひとときを 🥐',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['フォアグラ', 'コンフィ', 'ソース', 'デセール'],
  },
  chinese: {
    label: '中華',
    labelEn: 'Chinese',
    icon: '🥟',
    colors: {
      primary: '#c62828',
      secondary: '#ef5350',
      accent: '#ffcdd2',
    },
    welcomeMessage: 'ようこそ！本場の中華料理をどうぞ 🥟',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600&h=400&fit=crop',
      dimsum: 'https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=600&h=400&fit=crop',
    },
    categoryKeywords: ['餃子', 'チャーハン', '麻婆', '点心', '中華'],
  },
  general: {
    label: 'その他',
    labelEn: 'General',
    icon: '🍽️',
    colors: {
      primary: '#1976d2',
      secondary: '#42a5f5',
      accent: '#90caf9',
    },
    welcomeMessage: 'ようこそ！ごゆっくりお楽しみください 🍽️',
    placeholderImages: {
      main: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&h=400&fit=crop',
      drink: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&h=400&fit=crop',
      side: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=600&h=400&fit=crop',
    },
    categoryKeywords: [],
  },
};

/**
 * 店舗タイプからブランディング設定を取得
 */
export function getStoreTypeBranding(storeType) {
  return STORE_TYPES[storeType] || STORE_TYPES.general;
}

/**
 * カテゴリ名からプレースホルダー画像を取得
 */
export function getPlaceholderImageForCategory(storeType, categoryName) {
  const branding = getStoreTypeBranding(storeType);
  const lowerCat = (categoryName || '').toLowerCase();

  // ドリンク系
  if (lowerCat.includes('ドリンク') || lowerCat.includes('飲み物') || lowerCat.includes('drink')) {
    return branding.placeholderImages.drink;
  }

  // サイドメニュー系
  if (lowerCat.includes('サイド') || lowerCat.includes('一品') || lowerCat.includes('おつまみ')) {
    return branding.placeholderImages.side;
  }

  // デザート系
  if (lowerCat.includes('デザート') || lowerCat.includes('スイーツ') || lowerCat.includes('ケーキ')) {
    return branding.placeholderImages.dessert || branding.placeholderImages.side;
  }

  // 店舗タイプ固有のキーワードチェック
  for (const keyword of branding.categoryKeywords) {
    if (lowerCat.includes(keyword.toLowerCase())) {
      return branding.placeholderImages.main;
    }
  }

  // デフォルトはメイン画像
  return branding.placeholderImages.main;
}

/**
 * 店舗タイプのリスト（UI表示用）
 */
export const STORE_TYPE_OPTIONS = Object.entries(STORE_TYPES).map(([key, value]) => ({
  value: key,
  label: `${value.icon} ${value.label}`,
  labelEn: value.labelEn,
}));

export default STORE_TYPES;
